import "./windArrow.css";

interface WindArrowProps {
    /// Degrees the wind comes from (0 = north), as the forecast reports it
    bearing: number;
    size?: number;
}

/// Arrow pointing where the wind is blowing, the usual weather-map convention:
/// a wind from the north (0°) points down. Decorative; pair it with text.
export function WindArrow({ bearing, size = 12 }: WindArrowProps) {
    const toward = (bearing + 180) % 360;
    return (
        <svg
            className="wind-arrow"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2.6}
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ transform: `rotate(${toward}deg)` }}
            aria-hidden="true"
            focusable="false"
        >
            <path d="M12 20V4M6 10l6-6 6 6" />
        </svg>
    );
}
